import {
	InvestmentWorkflowCompletionStep,
	KycDocumentStatus,
} from '@dealstack/shared/lib/generated';
import type { VisibleCompletionStepsInput } from './InvestmentManage.types';

/**
 * Which "rejected files" sub-steps the investor still has something to do in. Extracted from the
 * sidebar `useMemo` so the KYC-forms rule is testable without booting the page.
 */
export const getVisibleCompletionSteps = ({
	proofOfIdentityStatus,
	proofOfAddressStatus,
	pivStatus,
	formStatus,
	isDeclarationsRejected,
	isPIVInvestment,
	hasKycFormAwaitingSignature,
}: VisibleCompletionStepsInput): (InvestmentWorkflowCompletionStep | '')[] => {
	const hidePIVKyc = !isPIVInvestment;

	return [
		proofOfIdentityStatus === KycDocumentStatus.UPLOADED_REJECTED ||
		proofOfIdentityStatus === KycDocumentStatus.NOT_UPLOADED ||
		proofOfAddressStatus === KycDocumentStatus.UPLOADED_REJECTED ||
		proofOfAddressStatus === KycDocumentStatus.NOT_UPLOADED
			? InvestmentWorkflowCompletionStep.KYC_PERSONAL
			: '',
		(pivStatus === KycDocumentStatus.UPLOADED_REJECTED ||
			pivStatus === KycDocumentStatus.NOT_UPLOADED) &&
		!hidePIVKyc
			? InvestmentWorkflowCompletionStep.KYC_COMPANY
			: '',
		// A submitted-but-unsigned form sits at UPLOADED_NOT_VERIFIED — neither missing nor rejected
		// — which would hide this step and leave the investor with no way to sign.
		formStatus === KycDocumentStatus.UPLOADED_REJECTED ||
		formStatus === KycDocumentStatus.NOT_UPLOADED ||
		hasKycFormAwaitingSignature
			? InvestmentWorkflowCompletionStep.KYC_FORMS
			: '',
		pivStatus === KycDocumentStatus.MORE_DOCUMENTS_REQUESTED && !hidePIVKyc
			? InvestmentWorkflowCompletionStep.OTHER
			: '',
		isDeclarationsRejected ? InvestmentWorkflowCompletionStep.DECLARATIONS : '',
	];
};
